export default class LatLonRequest {
  latitude: number
  longitude: number
}
